import { StateFlow1vjmqklz54iz7 as StateFlow } from './StateFlow.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import {
  $3l5vvh8yg0ier as $,
  orPromise1iucc2to2udt2 as orPromise,
} from '../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/coroutinesInteropJs.mjs';
import {
  equals2au1ep9vhcato as equals,
  hashCodeq5arwsb9dgti as hashCode,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { FunctionAdapter3lcrrz3moet5b as FunctionAdapter } from '../../../../kotlin-kotlin-stdlib/kotlin/js/FunctionAdapter.mjs';
import { FlowCollector26clgpmzihvke as FlowCollector } from './FlowCollector.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { get_NULL2w9d0rq01h4d4 as get_NULL } from './internal/NullSurrogate.mjs';
import { constructCallableReference23y65rf941mch as constructCallableReference } from '../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function get_defaultKeySelector() {
  _init_properties_Distinct_kt__4eindw();
  return defaultKeySelector;
}
var defaultKeySelector;
function get_defaultAreEquivalent() {
  _init_properties_Distinct_kt__4eindw();
  return defaultAreEquivalent;
}
var defaultAreEquivalent;
function distinctUntilChanged(_this__u8e3s4) {
  _init_properties_Distinct_kt__4eindw();
  var tmp;
  if (isInterface(_this__u8e3s4, StateFlow())) {
    tmp = _this__u8e3s4;
  } else {
    tmp = distinctUntilChangedBy(_this__u8e3s4, get_defaultKeySelector(), get_defaultAreEquivalent());
  }
  return tmp;
}
function distinctUntilChangedBy(_this__u8e3s4, keySelector, areEquivalent) {
  _init_properties_Distinct_kt__4eindw();
  var tmp;
  var tmp_0;
  var tmp_1;
  if (_this__u8e3s4 instanceof DistinctFlowImpl()) {
    tmp_1 = _this__u8e3s4.keySelector_1 === keySelector;
  } else {
    tmp_1 = false;
  }
  if (tmp_1) {
    tmp_0 = _this__u8e3s4.areEquivalent_1 === areEquivalent;
  } else {
    tmp_0 = false;
  }
  if (tmp_0) {
    tmp = _this__u8e3s4;
  } else {
    tmp = new (DistinctFlowImpl())(_this__u8e3s4, keySelector, areEquivalent);
  }
  return tmp;
}
var sam$kotlinx_coroutines_flow_FlowCollector$0Class;
function sam$kotlinx_coroutines_flow_FlowCollector$0() {
  if (sam$kotlinx_coroutines_flow_FlowCollector$0Class === VOID) {
    class $_0 {
      constructor(function_0) {
        this.function_1 = function_0;
      }
      *emit_t92u1f_k$(value, $completion) {
        return yield* $(this.function_1(value, $completion), $completion);
      }
      getFunctionDelegate_jtodtf_k$() {
        return this.function_1;
      }
      equals(other) {
        var tmp;
        if (!(other == null) ? isInterface(other, FlowCollector()) : false) {
          var tmp_0;
          if (!(other == null) ? isInterface(other, FunctionAdapter()) : false) {
            tmp_0 = equals(this.getFunctionDelegate_jtodtf_k$(), other.getFunctionDelegate_jtodtf_k$());
          } else {
            tmp_0 = false;
          }
          tmp = tmp_0;
        } else {
          tmp = false;
        }
        return tmp;
      }
      hashCode() {
        return hashCode(this.getFunctionDelegate_jtodtf_k$());
      }
    }
    initMetadataForClass($_0, 'sam$kotlinx_coroutines_flow_FlowCollector$0', VOID, VOID, [FlowCollector(), FunctionAdapter()], [1]);
    sam$kotlinx_coroutines_flow_FlowCollector$0Class = $_0;
  }
  return sam$kotlinx_coroutines_flow_FlowCollector$0Class;
}
function DistinctFlowImpl$collect$slambda(this$0, $previousKey, $collector) {
  return constructCallableReference((value, $completion) => orPromise($completion, function *($completion) {
    var key = this$0.keySelector_1(value);
    var tmp;
    if ($previousKey._v === get_NULL() || !this$0.areEquivalent_1($previousKey._v, key)) {
      $previousKey._v = key;
      tmp = yield* $collector.emit_t92u1f_k$(value, $completion);
    }
    return Unit_instance;
  }), 1);
}
var DistinctFlowImplClass;
function DistinctFlowImpl() {
  if (DistinctFlowImplClass === VOID) {
    class $ {
      constructor(upstream, keySelector, areEquivalent) {
        this.upstream_1 = upstream;
        this.keySelector_1 = keySelector;
        this.areEquivalent_1 = areEquivalent;
      }
      *collect_aksokr_k$(collector, $completion) {
        var previousKey = {_v: get_NULL()};
        var tmp = DistinctFlowImpl$collect$slambda(this, previousKey, collector);
        yield* this.upstream_1.collect_aksokr_k$(new (sam$kotlinx_coroutines_flow_FlowCollector$0())(tmp), $completion);
        return Unit_instance;
      }
    }
    initMetadataForClass($, 'DistinctFlowImpl', VOID, VOID, VOID, [1]);
    DistinctFlowImplClass = $;
  }
  return DistinctFlowImplClass;
}
function defaultKeySelector$lambda(it) {
  _init_properties_Distinct_kt__4eindw();
  return it;
}
function defaultAreEquivalent$lambda(old, new_0) {
  _init_properties_Distinct_kt__4eindw();
  return equals(old, new_0);
}
var properties_initialized_Distinct_kt_uy8c72;
function _init_properties_Distinct_kt__4eindw() {
  if (!properties_initialized_Distinct_kt_uy8c72) {
    properties_initialized_Distinct_kt_uy8c72 = true;
    defaultKeySelector = defaultKeySelector$lambda;
    defaultAreEquivalent = defaultAreEquivalent$lambda;
  }
}
//region block: exports
export {
  distinctUntilChanged as distinctUntilChanged3tb35h4hwds5o,
};
//endregion

//# sourceMappingURL=Distinct.mjs.map
